import React from 'react';

const EmptyTab = () => {

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
        }}
        >
            <img
                alt="Agyle"
                src="/image/agyle_logo.svg"
                title="Agyle Logo"
                style={{
                    width: '50%',
                    height: '50%',
                    opacity: 0.2,
                }}
            />
        </div>
    );
};

export default EmptyTab;